import { NgModule } from "@angular/core";
import { DebugService } from "./debug.service";
import { NotificationService } from "./notification.service";
import { MatSnackBarModule, MatSnackBar } from "@angular/material/snack-bar";
import { Overlay } from "@angular/cdk/overlay";
/**
 * Module that encapsulates all debug services
 */
@NgModule({
  imports: [MatSnackBarModule],
  providers: [MatSnackBar, Overlay, DebugService, NotificationService],
  declarations: [],
  exports: [MatSnackBarModule]
})
export class DebugModule { }
